<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11iYPMt/tc-custom/9781250123701.jpg?1731153895235" alt="This image is the cover for the book No Mortal Thing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Mortal Thing
      </h1>
      <p class="bookDescription body article font2">
        <p>Gerald Seymour's<i> No Mortal Thing</i> is a novel of relentless power and mounting suspense, a brilliant portrayal of organized crime in Europe and the under-resourced men and women who fight it.<br/><br/>Two young men - Jago and Marcantonio - both studying business and finance:<br/><br/>Jago is a kid from a rough part of London who has worked hard to get a job in a bank and is now on a fast-track to the Berlin office.<br/><br/> Marcantonio is one of the new generation in the ‘Ndrangheta crime families from Calabria, Southern Italy. He is in Germany to learn how to channel their illicit millions towards legitimate businesses all over Europe.<br/><br/> When Jago witnesses Marcantonio commit a vicious assault and the police seem uninterested, the Englishman refuses to let the matter drop.<br/><br/> But by pursuing the gangster to his grandfather’s mountain lair, Jago is stepping into the middle of a delicate surveillance operation, which sets alarm bells ringing in Rome, London, and Berlin. It also leads him to Consolata, a young woman who sees in Jago the chance to turn her non-violent protest campaign against the crime families into something altogether more lethal...</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gerald Seymour
      </h2>
      
      <p class="authorDescription body article">GERALD SEYMOUR was a reporter at ITN for fifteen years, where his first assignment was covering the Great Train Robbery in 1963. Seymour’s first novel was the acclaimed thriller <I>Harry’s Game</I>, set in Belfast, which became an instant international bestseller and later a television series. Six of Seymour’s thrillers have now been filmed for television in the UK and U.S.<I>No Mortal Thing</I> is his fourteenth novel.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c8f8a2c